import {Locale} from '../../../../../../../../../provider/locale/localization';

import * as styles from './appstore-invalid-credentials-notification.scss';

export function AppstoreInvalidCredentialsNotification(): JSX.Element {
    return (
        <div className={styles.AppstoreInvalidCredentialsNotification}>
            <p className={styles.AppstoreInvalidCredentialsNotification_reasonsIntro}>
                <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__INVALID_CREDENTIALS__REASONS" />
            </p>
            <ul className={styles.AppstoreInvalidCredentialsNotification_list}>
                <li>
                    <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__INVALID_CREDENTIALS__REASON_1" />
                </li>
                <li>
                    <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__INVALID_CREDENTIALS__REASON_2" />
                </li>
                <li>
                    <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__INVALID_CREDENTIALS__REASON_3" />
                </li>
            </ul>
            <p className={styles.AppstoreInvalidCredentialsNotification_footer}>
                <Locale stringKey="SOURCE_SETTINGS__ACCOUNTS__APPSTORE__INVALID_CREDENTIALS__FOOTER" />
            </p>
        </div>
    );
}
